
export default {
  productData: {
    serialNumber: 'DA-HMUL-001',
    name: 'Holzbalkendecken mit Unterdecken an Lattung | Aufbau 1',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 50',
          value: 'w-50'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 6 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 40',
          value: 'm-40'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Lattung' },
          output: '24',
          value: 'ba-24'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '368,5', value: 368.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '54 (2)',
        value: 54
      },
      soundReductionIndex: { // Rw
        output: '63 (-5; -11)',
        value: 63
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,26',
        value: 0.26
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '169,5 [kg/m²]'
      }
    }
  },
  image: 'da-hmul-001.png',
  pdf: 'Holzbalkendecken-mit-Unterdecke-an-Lattung-Aufbau-1-DA-HMUL-001-Rev02.pdf'
}
